<div class="modal-header confirmation-modal-default-bg-color">
    <h4 class="modal-title text-uppercase d-flex align-items-center" id="modal-title"><img width="40" class="me-2" src="assets/images/ai/ai-assistant-icon.png" alt="AI-Assistant" />{{ 'shortcutKeys.aiAssistant' | translation | async }}</h4>
    <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body align-items-center confirmation-modal-body">
    @switch (contentViewState()) {
        @case (ContentViewState.UserQuery) {
            <ng-container [ngTemplateOutlet]="infoTextTemplate"></ng-container>

            <div class="alert alert-light p-2 lh-base mb-2 alert-container" role="alert">
                <div class="fs-5 fw-medium">{{ 'aiAssistant.visualizationChoiceMessage' | translation | async }}</div>
                <div class="fs-6 font-weight-400">{{ 'aiAssistant.examplePrompts' | translation | async }}</div>
                <div class="alert alert-info p-1 m-0 mt-1" role="alert">
                    <small><i class="fa-solid fa-wand-magic-sparkles fa-sm me-1"></i>{{ 'aiAssistant.examplePromptsMessage1' | translation | async }}</small>
                </div>
                <div class="alert alert-info p-1 m-0 mt-1" role="alert">
                    <small><i class="fa-solid fa-wand-magic-sparkles fa-sm me-1"></i>{{ 'aiAssistant.examplePromptsMessage2' | translation | async }}</small>
                </div>
            </div>

            <ng-container [ngTemplateOutlet]="userPromptTemplate"></ng-container>
        }
        @case (ContentViewState.Loader) {
            <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        }
        @case (ContentViewState.Error) {
            <ng-container [ngTemplateOutlet]="infoTextTemplate"></ng-container>
            <div class="alert alert-danger p-2 mb-2 alert-container text-center" role="alert">
                <div>
                    <i class="fa-solid fa-triangle-exclamation fa-2x"></i>
                </div>
                <div class="mt-2 error-message">{{ errorMessage() }}</div>
            </div>
            <ng-container [ngTemplateOutlet]="userPromptTemplate"></ng-container>
        }
    }
</div>

<div class="modal-footer confirmation-modal-footer"></div>

<!-- Templates -->
<ng-template #infoTextTemplate>
    <div class="mb-3">
        <span class="fs-4 info-text-title">{{ 'aiAssistant.infoTextTitle' | translation | async }}</span>
        <span class="fs-4"> {{ 'aiAssistant.infoText' | translation | async }}</span>
    </div>
</ng-template>

<ng-template #userPromptTemplate>
    <div class="user-prompt-container border position-relative">
        <textarea #userPrompt id="user-prompt" class="none-outline border-0" rows="1" maxlength="255" [placeholder]="'aiAssistant.userPromptPlaceholder' | translation | async" (input)="onUserPromptChange()"></textarea>
        <button type="button" class="none-outline border-0 send-prompt-button position-absolute" (click)="submitUserPrompt()" [disabled]="!userPrompt.value?.length"><i class="fa-solid fa-arrow-right fa-lg"></i></button>
    </div>
</ng-template>

<ng-template #loadingTemplate>
    <div id="loader-container">
        <div id="colorful-loader-container" class="mt-5">
            <div class="colorful-loader"></div>
        </div>
        <div class="loader-message mt-3">{{ 'aiAssistant.loaderMessage' | translation | async }}</div>
        <ng-container #loaderRandomMessageRef></ng-container>
    </div>
</ng-template>

<ng-template #loaderMessageTemplateRef let-properties>
    <div class="loader-random-message text-center mt-3">{{ properties.message }}</div>
</ng-template>
<!-------------->
